module.exports = __webpack_public_path__ + "static/media/lisbon_hallway.20281b19.png";